import React from 'react';
import { IntlProvider, useIntl } from 'react-intl';
import { useEffect } from 'react';
import en_messages from 'locales/en.json';

const useSetupWindowUtils = () => {
  const intl = useIntl();
  useEffect(() => {
    const getFormattedMessageInEnglish = ({ id, values }) => {
      const englishIntlProvider = new IntlProvider(
        {
          locale: 'en',
          messages: en_messages,
        },
        {},
      );

      const { intl: englishIntl } = englishIntlProvider?.state;

      if (process.env.NODE_ENV !== 'production' && values) {
        Object.entries(values).forEach(([key, val]) => {
          if (React.isValidElement(val)) {
            const valProps = val.props || {};
            throw new Error(
              `[Form State Manager] Found React component (<FormattedMessage id="${valProps.id || 'unknown'}">) inside translation values for key "${id}" at value key "${key}". ` +
                'Values sent to Form State Manager must be plain strings or numbers to prevent circular structure serialization errors.',
            );
          }
        });
      }

      return englishIntl.formatMessage({ id }, values);
    };

    window.app = {
      ...(window.app || {}),
      intl: {
        ...intl,
        getFormattedMessageInEnglish,
      },
    };
  }, [intl]);
};

export default useSetupWindowUtils;
